/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import { withNamespaces } from 'react-i18next';
import scrollBlocker from '../../../utils/scrollBlocker';
import { colorsPalette } from '../../../styles/colors';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import {
  contentCss,
  overlayCss,
  iconCss,
  closeButtonCss,
} from './index.styles';

import './animate.css';

// Modal setup. For more info check https://github.com/reactjs/react-modal
// The if statement is needed due an issue with the tests. Check https://github.com/reactjs/react-modal/issues/632
if (process.env.NODE_ENV !== 'test' && typeof document !== 'undefined') {
  ReactModal.setAppElement(document.getElementById('root'));
}

class Modal extends SafePureComponent {
  static defaultProps = {
    onAfterOpen() {},
    onAfterClose() {},
  };

  onAfterOpen = () => {
    if (typeof this.props.onAfterOpen === 'function') {
      this.props.onAfterOpen();
    }
    scrollBlocker.enable();
  };

  onAfterClose = () => {
    if (typeof this.props.onAfterClose === 'function') {
      this.props.onAfterClose();
    }
    scrollBlocker.disable();
  };

  safeRender() {
    const {
      children,
      hideDefaultCloseButton,
      contentBackground,
      customCloseButtonCss,
      t,
      ...props
    } = this.props;

    return (
      <ReactModal
        {...props}
        style={{
          content: {
            ...contentCss(contentBackground),
            ...props.contentProp,
          },
          overlay: { ...overlayCss, ...props.overlayProp },
        }}
        onAfterOpen={this.onAfterOpen}
        onAfterClose={this.onAfterClose}
      >
        {!hideDefaultCloseButton && (
          <button
            onClick={this.props.onRequestClose}
            aria-label={t('Close')}
            css={[closeButtonCss, customCloseButtonCss]}
          >
            <span>
              <i css={iconCss} className="icon-closer" />
            </span>
            <span>{t('Close')}</span>
          </button>
        )}
        {children}
      </ReactModal>
    );
  }
}

Modal.displayName = 'Modal';

Modal.defaultProps = {
  hideDefaultCloseButton: false,
  contentBackground: colorsPalette.white,
  closeButtonCss: {},
  children: PropTypes.element,
  t: key => key,
};

export default withNamespaces()(Modal);
